import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import config from "../../config/config";
import Loader from "../loader/Loader";
import axios from "axios";
import ManpowerAllocationModal from '../modal/ManpowerAllocationModal';
import MachineModal from '../modal/MachineModal';
import { getAuthToken } from "../../utils/token";
import { formatDate } from '../../utils/formatDate';
const ProductionModal = ({ show, handleClose, productionId }) => {
    console.log(productionId,"productionId")
    const [loading, setLoading] = useState(false);
    const [manpowerAllocation, setManpowerAllocation] = useState(false)
    const [productionData, setproductionData] = useState([])
    const [machineShow, setMachineShow] = useState(false);
    const [mode, setMode] = useState('maintenance');
    // const [allocations, setAllocations] = useState([]);
    const [machineOperator, setMachineOperator] = useState({
        operators: [],
        machines: []
    });

    const fetchMachineOperator = async () => {
        const token = getAuthToken();
        if (!token) return;
        try {
            setLoading(true);
            const response = await axios.get(`${config.API}/supervisor/machineuser`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const data = response?.data || { operators: [], machines: [] };
             setMachineOperator(data);
            // setAllocations(
            //     data?.machines?.map(machine => ({
            //         machine_id: machine?.id,
            //         machine_code: machine?.machine_code,
            //         status: machine?.status,
            //         assigned: []
            //     }))
            // );
        } catch (err) {
            console.error("Error fetching machine/operator:", err.message);
            setMachineOperator({ operators: [], machines: [] });
            // setAllocations([]);
        } finally {
            setLoading(false)
        }
    };

    const fetchProduction = async () => {
        const token = getAuthToken();
        if (!token || !productionId) return;
        try {
            setLoading(true);
            const response = await axios.get(
                `${config.API}/supervisor/productionwithmachine/${productionId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            const result = response?.data;
            setproductionData(result);
        } catch (err) {
            console.error('Error fetching production data:', err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show && productionId) {
            fetchProduction();
            fetchMachineOperator()
        }
    }, [show, productionId]);

    const handleBackdropClick = (e) => {
        if (e.target.classList.contains('modal')) {
            handleClose();
        }
    };
    if (!show) return null;
    const openModal = (type) => {
        setMode(type);
        setMachineShow(true);
    };
    const production = productionData?.production?.[0];
    const machine = production?.machine;
    const operators = productionData?.assign_user || [];
    const totalOperators = productionData?.total_operators || 0;
    const date = productionData?.date ? formatDate(productionData.date) : "00/00/0000";
    const shift = productionData?.shift ;
    const currentUnits = production ? Number(production.total_units_produced) : 0;
    const targetUnits = production ? Number(production.machine?.capacity) : 0;
    const nonConformities = production ? Number(production.total_units_rejected) : 0;
    const percentage =
          targetUnits > 0 ? ((currentUnits / targetUnits) * 100).toFixed(2) : 0;
    return (
        <div
            className="modal d-block bg-dark bg-opacity-50 font_family"
            tabIndex="-1"
            role="dialog"
            onClick={handleBackdropClick}
        >
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content rounded shadow">
                    {loading ? (
                        <Loader />
                    ) : (
                        <div className="modal-body p-4">
                            <h5 className="fw-bold mb-1"> Production - {machine?.name} | {machine?.machine_code}</h5>
                            <div className="d-flex justify-content-between align-items-start mb-1">
                                <div>
                                    <div className="text-muted">Date: {date}</div>
                                    <div className="text-muted mb-1">Shift: {shift}</div>
                                </div>
                                <div className="text-end">
                                    <h6 className="mb-0 fw-bold">{percentage}%</h6>
                                    <small className="text-muted">efficiency</small>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <strong>Production Summary</strong>
                                <span className="text-muted small">
                                    {currentUnits} / {targetUnits}
                                </span>
                            </div>
                            <div className="progress mb-1" style={{ height: '6px' }}>
                                <div
                                    className="progress-bar bg-primary"
                                    style={{ width: `${percentage}%` }}
                                ></div>
                            </div>
                            <Row className="text-center mb-1 gx-3">
                                <Col style={{ backgroundColor: "#d1ecf1", borderRadius: '8px', padding: '1rem' }} className="mx-1">
                                    <h4 className="fw-bold mb-1">{currentUnits}</h4>
                                    <div className="text-muted">Units Produced</div>
                                </Col>
                                <Col style={{ backgroundColor: "#d1ecf1", borderRadius: '8px', padding: '1rem' }} className="mx-1">
                                    <h4 className="fw-bold mb-1">{targetUnits}</h4>
                                    <div className="text-muted">Target Units</div>
                                </Col>
                                <Col style={{ backgroundColor: "#d1ecf1", borderRadius: '8px', padding: '1rem' }} className="mx-1">
                                    <h4 className="fw-bold mb-1">{nonConformities}</h4>
                                    <div className="text-muted">Non-Conformities</div>
                                </Col>
                            </Row>
                            <div className="mb-4 p-3 rounded" style={{ backgroundColor: '#d1ecf1' }}>
                                <h6 className="fw-bold">Machine Information</h6>
                                <p className="mb-1 small">
                                    <span className="fw-semibold">Machine Code:</span> <span>{machine?.machine_code}</span>
                                </p>
                                <p className="mb-0 small">
                                    <span className="fw-semibold">Machine Type:</span> <span>{machine?.type}</span>
                                </p>
                                <div className="text-end">
                                    <span className="fw-semibold me-1">Machine Status:</span>
                                    <span className="badge bg-success px-3 py-2">{machine?.status}</span>
                                </div>
                            </div>
                            <div className="mb-4" style={{ backgroundColor: "#d1ecf1", borderRadius: '8px', padding: '1rem' }}>
                                <strong>Operator Information</strong>
                                <p className="mb-1 small">Number of Operators: <b>{totalOperators}</b></p>
                                <div className="d-flex gap-2 flex-wrap">
                                    <span>Operators Name :</span>
                                    {operators && operators.length > 0 ? (
                                        operators.map((op) => (
                                            <span
                                                key={op.operator_id}
                                                className="badge bg-light text-dark border px-3 py-2"
                                            >
                                                {op.user?.name}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="text-muted">No operators assigned</span>
                                    )}
                                </div>
                            </div>
                            <div className="d-flex justify-content-end gap-2">
                                <button className="btn btn-dark" onClick={() => setManpowerAllocation(true)}>
                                    Reassign Manpower
                                </button>
                                <button className="btn btn-dark" onClick={() => openModal('breakdown')}>
                                    Report Breakdown
                                </button>
                                <button
                                    className="btn btn-secondary"
                                    onClick={handleClose}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {/* ManpowerAllocationModal */}
            <ManpowerAllocationModal
                show={manpowerAllocation}
                handleClose={() => setManpowerAllocation(false)}
                machineOperator={machineOperator}
            />
            <MachineModal
                show={machineShow}
                handleClose={() => setMachineShow(false)} mode={mode}
            />
        </div>
    );
};

export default ProductionModal;
